
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import LessonLayout from '../../components/mdx/LessonLayout'
import styles from '../../scss/mdx.module.scss'

const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Image = makeShortcode("Image");
const layoutProps = {
  
};
const MDXLayout = ({ children }) => (
  <LessonLayout title="Learn">{children}</LessonLayout>
)

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <br />
    <h3 {...{
      "id": "curriculum"
    }}>{`Curriculum`}</h3>
    <p>{`The following lessons covers all the JavaScript foundations you would need to be
a full stack software engineer. To get started, go to `}<a parentName="p" {...{
        "href": "/signup"
      }}>{`c0d3.com/signup`}</a>{`
to sign up for an account. Make sure your password is > 8 characters.`}</p>
    <p>{`When you work as a software engineer, you can't study your way into success.
Most companies have bad documentation and use tools in a way that you have never
seen before. Therefore, communication and courageously asking for help is a
critical skill to becoming an impactful engineer.`}</p>
    <Image src="/assets/docs/learn/join_discord.png" height="251" width="1267" proportions="long" mdxType="Image" />
    <p>{`In order to ask for help, make sure to join our
`}<a parentName="p" {...{
        "href": "https://discord.gg/c0d3"
      }}>{`Discord`}</a>{` server. You will need to `}<strong parentName="p">{`Sign up`}</strong>{` for a
new Discord account, if you already have an account, you can just `}<strong parentName="p">{`Sign in`}</strong></p>
    <br />
    <twoColumns>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        marginRight: '2em'
      }}>
        <Image src="/assets/docs/learn/discord_rules.png" height="353" width="245" proportions="tall" mdxType="Image" />
        <Image src="/assets/docs/learn/discord_lessons.png" height="390" width="245" proportions="tall" mdxType="Image" />
      </div>
      <div>
        <p>{`After joining the Discord, you'll need to read the rules and introduce yourself
a little bit.`}</p>
        <p>{`In the `}<inlineCode parentName="p">{`Lessons`}</inlineCode>{` category, click on the channel for the chapter you are studying
to ask questions if you find any concepts confusing or are experiencing issues.`}</p>
        <p>{`You should get a response in < 3 hours.`}</p>
        <p>{`Issues creating an account or getting access to chat? Email
`}<inlineCode parentName="p">{`song@garagescript.org`}</inlineCode>{` and I can look into it for you`}</p>
        <p>{`In the unlikely event you do not receive any response, you can also reach out
via`}</p>
        <p><em parentName="p">{`(in order of preference / response time)`}</em></p>
        <ul>
          <li parentName="ul"><strong parentName="li">{`Keybase`}</strong>{` (@songz)`}</li>
          <li parentName="ul"><strong parentName="li">{`Twitter`}</strong>{` (@songz)`}</li>
        </ul>
      </div>
    </twoColumns>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;